export interface ContactoEmergenciaView {
  nome: string;
  telefone: string;
}

const PLACEHOLDERS = new Set(['-', '—']);

function textoValido(valor: unknown): string {
  if (typeof valor !== 'string') return '';
  const texto = valor.trim();
  return PLACEHOLDERS.has(texto) ? '' : texto;
}

export function obterContactoEmergencia(
  nome: unknown,
  telefone: unknown,
): ContactoEmergenciaView | null {
  const nomeValido = textoValido(nome);
  const telefoneValido = textoValido(telefone);

  if (!nomeValido || !telefoneValido) return null;

  return {
    nome: nomeValido,
    telefone: telefoneValido,
  };
}

export function telefoneParaLigacao(telefone: string): string {
  return telefone.replace(/[^\d+]/g, '');
}
